import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-centered-image-card',
  styleUrls: [],
  shadow: false,
})
export class DdaCenteredImageCard {
  @Prop() image_src: string;
  @Prop() image_alt: string;
  @Prop() header_text: string;
  @Prop() info_text: string;
  @Prop() date_text: string;
  @Prop() left_button_name: string;
  @Prop() right_button_name: string;
  @Prop() left_button_id: string;
  @Prop() right_button_id: string;
  // @Prop() single_button: boolean;
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 

  @Prop() clickHandler?: (event: MouseEvent) => void;

  handleButtonClick = (event: CustomEvent<{ event: MouseEvent; id: string; value?: string; name?: string; }>) => {
    if (this.clickHandler) {
      this.clickHandler(event.detail.event);
    }
    console.log('Button clicked inside parent:', event.detail);
  }
  noop = () => {};
  
  
  render() {
    const cardClass = [
      'dda-card',
      this.custom_class ? `${this.custom_class}` : "",
      this.component_mode,
    ].filter(Boolean).join(' ');


    return (
      <Host>
        <div class={cardClass}>
          <div class="dda-container-fluid dda-pt-3 dda-d-flex dda-flex-column dda-gap-2">
            {this.info_text && <p class="body Regular">
              {this.info_text}
            </p>}
            {this.date_text && <p class="body Regular">{this.date_text}</p>}
            <h6 class="h6 Regular">
              {this.header_text}
            </h6>
            <img class="dda-card-img image-card dda-rounded-md" src={this.image_src} alt={this.image_alt}/>
          </div>    
          <div class="dda-container-fluid dda-pt-3">
              <div class="dda-row">
                {this.left_button_name ?
                <div class="dda-col dda-pb-3">
                    <dda-button 
                      button_color="default-tertiary" 
                      button_text={this.left_button_name} 
                      button_id={this.left_button_id}
                      value={this.left_button_name}
                      aria_label={this.left_button_name} 
                      button_name={this.left_button_name}  
                      onButtonClick={this.handleButtonClick} 
                      // onpressKey={() => console.log()} 
                      custom_class="dda-w-100" 
                      component_mode=""  
                    ></dda-button>
                </div>
                : null}

                {this.right_button_name ? 
                <div class="dda-col dda-pb-3">
                    <dda-button 
                      button_color="default-primary"  
                      button_text={this.right_button_name} 
                      button_id={this.right_button_id}
                      value={this.right_button_name}
                      aria_label={this.right_button_name} 
                      button_name={this.right_button_name}
                      onButtonClick={this.handleButtonClick} 
                      // onpressKey={() => console.log()} 
                      custom_class="dda-w-100" 
                      component_mode=""  
                    ></dda-button>
                </div>
                : null}
              </div>
            </div>
        </div>
      </Host>
    );
  }
}
